import * as React from 'react';

import { ActionableContainer, type ActionableContainerProps } from '../ActionableContainer';
import { FieldContextProvider } from './FieldContext';

export type FieldGroupProps = ActionableContainerProps;
/**
 * Used to display a field with a label, an input and a description.
 * @example
 * // Vertical
 * <FieldGroup>
 *   <Label>Title</Label>
 *   <Description>Some description</Description>
 *   <TextInput />
 * </FieldGroup>
 *
 * // Horizontal
 * <FieldGroup orientation="horizontal">
 *   <Group>
 *     <Label>Title</Label>
 *     <Description>Some description</Description>
 *   </Group>
 *   <TextInput />
 * </FieldGroup>
 */
export function FieldGroup({
    ref,
    ...props
}: FieldGroupProps & { ref?: React.ForwardedRef<HTMLDivElement> }) {
    return (
        <FieldContextProvider>
            <ActionableContainer ref={ref} {...props} />
        </FieldContextProvider>
    );
}
